var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-builder"},[_c('CustomFields',{attrs:{"schema":_vm.schema,"data":_vm.valueComp,"validator":_vm.validator},model:{value:(_vm.valueComp),callback:function ($$v) {_vm.valueComp=$$v},expression:"valueComp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }